export class NetworkDataRequest {
    public ping: string;
    public internetSpeed: string;
    public percentPing: string;
}